import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import React from 'react';

interface IToogleText {
  text: string;
  onPressLeft: () => void;
  onPressRight: () => void;
  showRight: boolean;
  showLeft: boolean;
}

export const SwitchDates: React.FC<IToogleText> = ({ onPressLeft, onPressRight, text, showLeft, showRight }) => {
  return (
    <div className="flex items-center gap-1">
      <button onClick={onPressLeft} className={showLeft ? 'visible border-1 border-blue-600 rounded-full' : 'hidden'}>
        <ChevronLeftIcon className="text-blue-600" />
      </button>
      <p className="text-base text-secondary my-1">{text}</p>
      {showRight && (
        <button onClick={onPressRight} className=" border-1 border-blue-600 rounded-full">
          <ChevronRightIcon className="text-blue-600" />
        </button>
      )}
    </div>
  );
};
